/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesChannel } from './SalesChannel';
import {
    SalesChannelFromJSON,
    SalesChannelFromJSONTyped,
    SalesChannelToJSON,
} from './SalesChannel';

/**
 * Fast play game - extends import type with required salesChannel
 * @export
 * @interface FastPlayGame
 */
export interface FastPlayGame {
    /**
     * Optional logo image URL for the game
     * @type {string}
     * @memberof FastPlayGame
     */
    logoUrl?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FastPlayGame
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FastPlayGame
     */
    activeFrom: Date;
    /**
     * 
     * @type {string}
     * @memberof FastPlayGame
     */
    gameId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FastPlayGame
     */
    ticketCostInCents: number;
    /**
     * 
     * @type {SalesChannel}
     * @memberof FastPlayGame
     */
    salesChannel: SalesChannel;
    /**
     * 
     * @type {boolean}
     * @memberof FastPlayGame
     */
    hasProgressiveJackpots: boolean;
    /**
     * 
     * @type {string}
     * @memberof FastPlayGame
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FastPlayGame
     */
    jackpotGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FastPlayGame
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof FastPlayGame
     */
    id: string;
}



/**
 * Check if a given object implements the FastPlayGame interface.
 */
export function instanceOfFastPlayGame(value: object): value is FastPlayGame {
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('ticketCostInCents' in value) || value['ticketCostInCents'] === undefined) return false;
    if (!('salesChannel' in value) || value['salesChannel'] === undefined) return false;
    if (!('hasProgressiveJackpots' in value) || value['hasProgressiveJackpots'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FastPlayGameFromJSON(json: any): FastPlayGame {
    return FastPlayGameFromJSONTyped(json, false);
}

export function FastPlayGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): FastPlayGame {
    if (json == null) {
        return json;
    }
    return {
        
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': (new Date(json['activeFrom'])),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'ticketCostInCents': json['ticketCostInCents'],
        'salesChannel': SalesChannelFromJSON(json['salesChannel']),
        'hasProgressiveJackpots': json['hasProgressiveJackpots'],
        'name': json['name'],
        'jackpotGroupId': json['jackpotGroupId'] == null ? undefined : json['jackpotGroupId'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function FastPlayGameToJSON(value?: FastPlayGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'logoUrl': value['logoUrl'],
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': ((value['activeFrom']).toISOString()),
        'gameId': value['gameId'],
        'ticketCostInCents': value['ticketCostInCents'],
        'salesChannel': SalesChannelToJSON(value['salesChannel']),
        'hasProgressiveJackpots': value['hasProgressiveJackpots'],
        'name': value['name'],
        'jackpotGroupId': value['jackpotGroupId'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

